// apps/admin-ui/src/components/ui/TopbarTabs.tsx
import { NavLink } from 'react-router-dom';
import {
  Users,
  Filter,
  Workflow,
  Megaphone,
  FileText,
  CalendarDays,
  MapPin,
  Award,
  Layers,
  Images,
  Link2,
  Activity,
  Zap,
  BarChart3,
  Plug,
  Key,
  Blocks,
  UsersRound,
  Settings,
  ClipboardList,
  type LucideIcon,
} from 'lucide-react';
import { cn } from './cn.ts';

interface Tab {
  to: string;
  label: string;
  icon: LucideIcon;
  end?: boolean;
}

const AREA_TABS: Record<string, Tab[]> = {
  audience: [
    { to: '/customers', label: 'Customers', icon: Users },
    { to: '/segments', label: 'Segments', icon: Filter },
  ],
  marketing: [
    { to: '/automations', label: 'Automations', icon: Workflow },
    { to: '/campaigns', label: 'Campaigns', icon: Megaphone },
    { to: '/templates', label: 'Templates', icon: FileText },
  ],
  events: [
    { to: '/events', label: 'Events', icon: CalendarDays, end: true },
    { to: '/events/tours', label: 'Tours', icon: MapPin },
  ],
  loyalty: [
    { to: '/loyalty', label: 'Programs', icon: Award },
  ],
  content: [
    { to: '/spaces', label: 'Spaces', icon: Layers },
    { to: '/media', label: 'Media', icon: Images },
    { to: '/shortlinks', label: 'Shortlinks', icon: Link2 },
    { to: '/questionnaires', label: 'Questionnaires', icon: ClipboardList },
  ],
  data: [
    { to: '/signals', label: 'Signals', icon: Activity, end: true },
    { to: '/signal-types', label: 'Signal Types', icon: Zap },
    { to: '/analytics', label: 'Analytics', icon: BarChart3 },
  ],
  settings: [
    { to: '/integrations', label: 'Integrations', icon: Plug },
    { to: '/cms/tokens', label: 'API Tokens', icon: Key },
    { to: '/cms/block-defs', label: 'Block Defs', icon: Blocks },
    { to: '/team', label: 'Team', icon: UsersRound },
    { to: '/settings/properties', label: 'Settings', icon: Settings },
  ],
};

export function TopbarTabs({ area }: { area: string }) {
  const tabs = AREA_TABS[area];
  if (!tabs) return <div className="flex-1 min-w-0" />;

  return (
    <nav className="flex items-center gap-1 flex-1 min-w-0">
      {tabs.map(({ to, label, icon: Icon, end }) => (
        <NavLink
          key={to}
          to={to}
          end={end}
          className={({ isActive }) =>
            cn(
              'flex items-center gap-1.5 px-2.5 py-1 rounded-md text-sm font-medium transition-colors whitespace-nowrap',
              isActive
                ? 'bg-zinc-100 text-zinc-900'
                : 'text-zinc-500 hover:bg-zinc-50 hover:text-zinc-700',
            )
          }
        >
          <Icon size={14} className="shrink-0" />
          {label}
        </NavLink>
      ))}
    </nav>
  );
}
